<template>
<w-settings-content-template side-title="네트워크 목록">
  <w-physical-tree ref="sideTree" slot="sideContent" managetype-id="NMS" force-select-leaf @clickNode="onClickNode" />
  <el-tabs slot="content" class="content-tap" type="card" v-model="activeTab">
    <el-tab-pane label="사용자 정의 OID" name="WUserDefineOidView" class="h100 w100">
      <w-user-define-oid-view :activeTab="activeTab" :selectPhysicalNode="selectPhysicalNode" />
    </el-tab-pane>
    <!-- TODO 결과값 템플릿에 대한 기획 추후 보강 후 개발 예정 -->
    <!-- <el-tab-pane label="결과값 템플릿" name="WProcessBatchRegistView" class="h100 w100">
    </el-tab-pane> -->
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WUserDefineOidView from '@/views/settings/netdevice/OidSettings/UserDefineOidSettings/component/UserDefineOidView';
import WPhysicalTree from '@/components/tree/DynamicPhysicalTree';

export default {
  name: 'WUserDefineOidSettings',
  components: {
    WPhysicalTree,
    WSettingsContentTemplate,
    WUserDefineOidView,
  },
  data() {
    return {
      activeTab: 'WUserDefineOidView',
      selectPhysicalNode: null,
    };
  },
  methods: {
    /**
     * [onClickNode 네트워크 목록 트리 선택시 선택된 노드 정보를 저장한다.]
     * @author yelim
     */
    onClickNode(data) {
      this.selectPhysicalNode = data;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/UserDefineOidSettings/index.vue